import { ActivatedRoute } from "@angular/router";
import { NavigationSegment } from "../models/breadcrumb/breadcrumb-item.model";

export class NavigationHelper {
    
    static readonly routeDataBreadcrumb: string = "breadcrumb";
    static getNaviationSegments(activatedRoute: ActivatedRoute, url: string = "", items: NavigationSegment[] = []): NavigationSegment[] {
        let children: ActivatedRoute[] = activatedRoute.children;
        //iterate over each children
        for (let child of children) {
            //verify primary route
            if (child.outlet !== "primary") {
                continue;
            }
    
            //get the route's URL segment
            const routeUrl = child.snapshot.url.map(segment => segment.path).join("/");
    
            //append route URL to URL
            url += `/${routeUrl}`;
            //verify the custom data property "breadcrumb" is specified on the route
            if (!child.snapshot.data.hasOwnProperty(NavigationHelper.routeDataBreadcrumb) || (items.length > 0 && items[items.length-1].label.trim() === child.snapshot.data[NavigationHelper.routeDataBreadcrumb])) {
                return this.getNaviationSegments(child, url, items);
            }
    
            //add breadcrumb
            let breadcrumb: NavigationSegment = {
                label: child.snapshot.data[NavigationHelper.routeDataBreadcrumb],
                routerLink: url,
                fragment: undefined
            };
            items.push(breadcrumb);
    
            //recursive
            return this.getNaviationSegments(child, url, items);
        }
    
        //we should never get here, but just in case
        return items;
      }
}